import { TextField } from '@/components/ui/TextField';
import { SelectField } from '@/components/ui/SelectField';
import { SettingsCard } from './fields';
import type { SettingsSectionProps } from './fields';

const TIMEZONE_OPTIONS = [
  { value: 'Asia/Kolkata', label: 'Asia/Kolkata (IST)' },
  { value: 'Asia/Dubai', label: 'Asia/Dubai (GST)' },
  { value: 'Asia/Singapore', label: 'Asia/Singapore (SGT)' },
  { value: 'Europe/London', label: 'Europe/London (GMT/BST)' },
  { value: 'America/New_York', label: 'America/New_York (ET)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles (PT)' },
];

const CURRENCY_OPTIONS = [
  { value: 'INR', label: 'INR · ₹' },
  { value: 'USD', label: 'USD · $' },
  { value: 'EUR', label: 'EUR · €' },
  { value: 'GBP', label: 'GBP · £' },
  { value: 'AED', label: 'AED · د.إ' },
  { value: 'SGD', label: 'SGD · S$' },
];

export function getBrandNameError(value: string) {
  if (!value) {
    return 'Brand name is required';
  }
  if (value.length < 5) {
    return 'Brand name must be at least 5 characters';
  }
  return undefined;
}

export function getSupportEmailError(value: string) {
  if (!value) {
    return 'Support email is required';
  }
  if (!value.includes('@')) {
    return 'Enter a valid email address';
  }
  return undefined;
}

export function getSupportPhoneError(value: string) {
  if (!value) {
    return 'Support phone is required';
  }
  if (value.length !== 10) {
    return 'Phone number must be exactly 10 digits';
  }
  return undefined;
}

export function GeneralSection({ settings, onChange }: SettingsSectionProps) {
  const brandName = settings.customDomain ?? '';
  const supportEmail = settings.merchantNotifyEmail ?? '';
  const supportPhone = settings.merchantPhone ?? '';

  return (
    <div className="flex flex-col gap-4">
      <SettingsCard title="Store profile" description="Basic contact and locale details for your store.">
        <TextField
          label="Brand name"
          requiredMark
          placeholder="fastrr Checkout & returns"
          maxLength={50}
          value={brandName}
          onChange={(event) => onChange({ customDomain: event.target.value })}
          errorText={getBrandNameError(brandName)}
        />
        <TextField
          label="Support email"
          requiredMark
          type="email"
          placeholder="fastrrcheckoutreturns@fastrr.com"
          value={supportEmail}
          onChange={(event) => onChange({ merchantNotifyEmail: event.target.value })}
          errorText={getSupportEmailError(supportEmail)}
        />
        <TextField
          label="Support phone"
          requiredMark
          type="tel"
          placeholder="9876543210"
          maxLength={10}
          value={supportPhone}
          onChange={(event) => {
            const value = event.target.value.replace(/\D/g, '').slice(0, 10);
            onChange({ merchantPhone: value });
          }}
          errorText={getSupportPhoneError(supportPhone)}
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <SelectField
            label="Timezone"
            value={settings.timezone ?? 'Asia/Kolkata'}
            onChange={(event) => onChange({ timezone: event.target.value })}
            options={TIMEZONE_OPTIONS}
          />
          <SelectField
            label="Display currency"
            value={settings.displayCurrency ?? 'INR'}
            onChange={(event) => onChange({ displayCurrency: event.target.value })}
            options={CURRENCY_OPTIONS}
          />
        </div>
      </SettingsCard>
    </div>
  );
}
